import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import MainLayout from "src/layouts/main";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { PATH_AFTER_LOGIN } from "../config-global";
//
import {
  // Auth
  LoginPage,

  // Dashboard: General
  GeneralAppPage,

  // Dashboard: Report
  GeneralReportPage,

  // Dashboard: Staff
  UserListPage,
  UserEditPage,
  UserCreatePage,

  // Dashboard: Menu
  MenuDisplayPage,
  ItemCreatePage,
  ItemEditPage,

  // Dashboard: Category
  CategoryCreatePage,
  CategoryEditPage,

  // Dashboard: Customer
  CustomerListPage,
  CustomerEditPage,
  CustomerCreatePage,
  CustomerInfoPage,

  // Dashboard: Desigination
  DesiginationCreatePage,
  DesiginationEditPage,

  // Dashboard: Settings
  SettingsCreatePage,
  UserAccountPage,

  // Dashboard: store
  StorePage,
  FranchiseThemePreviewPage,
  ThemeEditPage,

  // DASHBOARD: Pages
  PageCreatePage,
  PageEditPage,
  PageListPage,
  // Other
  Page500,
  Page403,
  Page404,
} from "./elements";
import PrivateRoute from "./PrivateRoute";
export default function Router() {
  return useRoutes([
    // Auth
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },

    // Dashboard
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "app",
          element: (
            <PrivateRoute
              component={GeneralAppPage}
              permission="canViewDashboard"
            />
          ),
        },
        {
          path: "report",
          element: (
            <PrivateRoute
              component={GeneralReportPage}
              permission="canAccessReports"
            />
          ),
        },

        {
          path: "user",
          children: [
            {
              element: <Navigate to="/dashboard/user/profile" replace />,
              index: true,
            },
            { path: "list", element: <UserListPage /> },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={UserCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: <UserEditPage />,
            },
            {
              path: ":id/replicate",
              element: <UserEditPage />,
            },
            {
              path: "account",
              element: (
                <PrivateRoute
                  component={UserAccountPage}
                  permission="canViewStaff"
                />
              ),
            },
          ],
        },

        {
          path: "menu",
          children: [
            {
              element: <Navigate to="/dashboard/menu/profile" replace />,
              index: true,
            },
            {
              path: "display",
              element: <MenuDisplayPage />,
            },
          ],
        },

        {
          path: "item",
          children: [
            {
              element: <Navigate to="/dashboard/item/profile" replace />,
              index: true,
            },
            { path: "new", element: <ItemCreatePage /> },
            { path: ":id/edit", element: <ItemEditPage /> },
            { path: ":id/replicate", element: <ItemEditPage /> },
          ],
        },
        {
          path: "category",
          children: [
            {
              element: <Navigate to="/dashboard/category/profile" replace />,
              index: true,
            },
            { path: "new", element: <CategoryCreatePage /> },
            { path: ":id/edit", element: <CategoryEditPage /> },
            { path: ":id/replicate", element: <CategoryEditPage /> },
          ],
        },
        {
          path: "customer",
          children: [
            {
              element: <Navigate to="/dashboard/customer/profile" replace />,
              index: true,
            },
            {
              path: "list",
              element: (
                <PrivateRoute
                  component={CustomerListPage}
                  permission="canViewVenueCustomers"
                />
              ),
            },
            { path: "new", element: <CustomerCreatePage /> },
            { path: ":id/edit", element: <CustomerEditPage /> },
            { path: ":id/profile", element: <CustomerInfoPage /> },
          ],
        },
        {
          path: "store",
          children: [
            {
              path: "themes",
              element: <StorePage />,
            },
            {
              path: "themes/Preview/:themeName",
              element: <FranchiseThemePreviewPage />,
            },

            {
              path: "themes/:themeName/edit",
              element: <ThemeEditPage />,
            },
          ],
        },
        {
          path: "page",
          children: [
            {
              element: <Navigate to="/dashboard/customer/profile" replace />,
              index: true,
            },
            {
              path: "list",
              element: <PageListPage />
            },
            { path: "new", element: <PageCreatePage /> },
            { path: ":id/edit", element: <PageEditPage /> },
            { path: ":id/profile", element: <CustomerInfoPage /> },
          ],
        },

        {
          path: "desigination",
          children: [
            {
              element: <Navigate to="/dashboard/user/account" replace />,
              index: true,
            },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={DesiginationCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: (
                <PrivateRoute
                  component={DesiginationEditPage}
                  permission="canEditStaffDetails"
                />
              ),
            },
          ],
        },

        {
          path: "settings",
          children: [
            {
              element: <Navigate to="/dashboard/settings/new" replace />,
              index: true,
            },
            { path: "new", element: <SettingsCreatePage /> },
          ],
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [
        { path: "500", element: <Page500 /> },
        { path: "404", element: <Page404 /> },
        { path: "403", element: <Page403 /> },
      ],
    },
    {
      element: <MainLayout />,
      children: [
        {
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
          index: true,
        },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
